export default __webpack_public_path__ + "static/Collective-Haus-Sudbury_Team_06-2023-fafa5fbdac3df4b5098754493ff5248f.jpg";